<template>
  <div>
    <b-breadcrumb
      :items="breadcrumb"
      style="margin-bottom: 0px;"
    ></b-breadcrumb>
    <main-title title="Autoras y autores" />
    <div class="d-flex justify-content-between alphabetFilter">
      <div>
        <b-link
          @click="clearFilter()"
          >#</b-link
        >
      </div>
      <div v-for="font in fonts" :key="font">
        <b-link
          @click="filterBy(font)"
          :class="{ active: activeFiler === font }"
          v-if="activeFonts.includes(font)"
          >{{ font }}</b-link
        >
        <b-link class="text-secondary" v-else>
          {{font}}
        </b-link>
      </div>
    </div>
    <transition name="fade">
      <div class="d-flex flex-wrap authorList" v-if="!hideList">
        <div
          v-for="author in filterAuthors"
          :key="author.id"
          class="p-4 text-center authorPic"          
          @click="loadDetails(author.id)"
        >
          <b-avatar size="150px" :src="$store.state.user.siteData.location +
                'repository/authors/' + author.id  + '_small'" />
          <br />
          <br />
          <div style="font-size: larger; font-weight: 500;">{{author.name}} {{author.lastname}}</div>
          <div class="small text-muted">
            {{author.resume}}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import axios from "axios";

export default {
  components: {
    MainTitle
  },
  data: function() {
    return {
      breadcrumb: [
        {
          text: "Inicio",
          to: { name: "Home" }
        },
        {
          text: "Autores",
          to: { name: "Autores" }
        },
        {
          text: "Todos",
          active: true
        }
      ],
      hideList: false,
      activeFiler: "",
      fonts: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      activeFonts:[],
      authors: [],
      filterAuthors: []
    };
  },
  mounted(){
    this.updateAuthors();
  },
  methods: {
    filterBy(letter) {
      this.breadcrumb.splice(2, 1, { text: letter, active: true });
      this.activeFiler = letter;
      this.hideList = true;
      setTimeout(
        function() {
          this.filterAuthors = [];
          this.authors.forEach(element => {
            if (element.lastname && element.lastname[0] === this.activeFiler){
              this.filterAuthors.push(element);
            }
          });
          this.hideList = false;
        }.bind(this),
        500
      );
    },
    clearFilter(){
      this.breadcrumb.splice(2, 1, { text: 'Todos', active: true });
      this.activeFiler = "";
      this.hideList = true;
      setTimeout(
        function() {
          this.filterAuthors = this.authors.slice(0);
          this.hideList = false;
        }.bind(this),
        500
      );
    },
    loadDetails(item) {
      this.$router.push({ name: "AutoresDetail", params: { id: item } });
    },
    async updateAuthors(){
      console.log(this.$store.state.user.siteData);
      this.activeFonts = [];

      this.authors = await axios
        .post(
          this.$store.state.user.siteData.location + "authors/authors",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              id: element.id,
              name: element.name,
              lastname: element.lastname,
              resume: element.resumemin
            });
            if (element.lastname && !this.activeFonts.includes(element.lastname[0])){
              this.activeFonts.push(element.lastname[0]);
            }
          });
          
          this.filterAuthors = result;
          return result;
        });
    },
  }
};
</script>
